import React from 'react';
import { FadeIn } from './FadeIn';
export function Story() {
  return <section className="py-20 md:py-24 px-6 bg-cream-dark/30" data-id="element-104" data-mp="1icf86slelj2c">
      <div className="max-w-reading mx-auto" data-id="element-105" data-mp="1iauef56wy45j">
        <FadeIn data-id="element-106" data-mp="1n3dse39ij1av">
          <div className="flex items-center gap-4 mb-12" data-id="element-107" data-mp="1n2vkg9dhmyn4">
            <h2 className="font-playfair text-3xl md:text-4xl text-charcoal italic" data-id="element-108" data-mp="1n5hssb87di6e">
              My Story
            </h2>
            <div className="h-px flex-grow bg-amber/30 mt-2" data-id="element-109" data-mp="ueq2tvhqdpri" />
          </div>
        </FadeIn>

        <div className="space-y-6 md:space-y-8 text-base md:text-xl text-charcoal/80 leading-relaxed font-light" data-id="element-110" data-mp="zdb0bn5llvc9">
          <FadeIn delay={0.1} data-id="element-111" data-mp="14ce7pe91wdne">
            <p data-id="element-112" data-mp="14b2tsllw5pik">
              I've always been drawn to understanding how things work—not just
              the surface-level answer, but the reasoning, structure, and
              decision-making behind it. That curiosity is a major part of what
              led me to the legal field. Law shapes the way individuals,
              businesses, and institutions make decisions, resolve disputes,
              protect their interests, and define their responsibilities. I find
              that combination of logic, strategy, communication, and real-world
              impact genuinely compelling.
            </p>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-113" data-mp="v2ah5fwwrt88">
            <p data-id="element-114" data-mp="v321tvoyw6jq">
              I'm currently enrolled in the UCLA Paralegal Training Program,
              where I've had the opportunity to develop a practical
              understanding of the legal process through coursework in civil
              litigation, contracts, legal research, and legal writing. The
              program has challenged me to think carefully, write precisely,
              analyze issues from multiple angles, and work through legal
              problems in a structured and disciplined way.
            </p>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-115" data-mp="7eixtscyafxg">
            <p data-id="element-116" data-mp="2dd01g4fo2h2">
              What I enjoy most about the field is that strong legal work
              requires more than simply knowing the rules. It requires
              understanding how those rules apply to specific facts,
              communicating clearly with different people, staying organized
              under pressure, and paying close attention to details that can
              materially affect an outcome. Those are skills I have always
              valued and continue to strengthen through both my academic and
              professional experience.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-117" data-mp="gejw2fo0lb5v">
            <p data-id="element-118" data-mp="ges9c8o1uihl">
              As I continue building my career in law, I'm especially interested
              in opportunities where I can contribute to a team, learn from
              experienced attorneys and paralegals, and develop meaningful
              hands-on experience in civil litigation and legal support. I
              approach that process with curiosity, discipline, strong
              communication skills, and a genuine desire to understand the work
              at a deeper level.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}